import ajax, { init } from "@/lib/ajax";
//import { getBusinessId } from "./business";
import * as tokenStore from "./token";

let refreshTid;
export async function info() {
    const token = tokenStore.get();
    if (token) {
        // 如果没 token 还去请求后台接口，会命中 10102
        // 因此这里没 token 照样放行无所谓
        init({ headers: { Authorization: token } });
    }
    const result = await ajax.get("/xiaoyue-operation/member/info");
    // 定时刷新 token
    refresh();
    return { ...result, token };
}

// token 60分钟会过期，50分钟换取新的token
export async function refresh() {
    const lastSetTokenTime = tokenStore.getSetTime();
    const intervals = Date.now() - lastSetTokenTime;
    const needRefresh = intervals > 50 * 60 * 1000;
    if (!needRefresh) {
        refreshTid && clearTimeout(refreshTid);
        refreshTid = setTimeout(refresh, 50 * 60 * 1000 - intervals);
        return;
    }
    const { token } = await ajax.post("/xiaoyue-operation/login/refresh");
    tokenStore.set(token);
    await info();
}

export async function login(name, pw, ticket, randstr, redirect) {
    const result = await ajax.post("/xiaoyue-operation/login", { name, pw, ticket, randstr });
    const { token } = result;
    tokenStore.set(token);
    jump(redirect);
    return;
}

export async function logout() {
    tokenStore.clear();
    jump("login");
}

export async function jump(where) {
    const prefix = (() => {
        const pageUrl = window.location.href.split("?")[0].split("#")[0];
        const hasHtml = pageUrl.indexOf("html") > -1;
        if (hasHtml) {
            const urlSplices = pageUrl.split("/");
            urlSplices.pop();
            return urlSplices.join("/");
        }

        return "";
    })();
    const home = `${prefix}/index.html`;
    const login = `${prefix}/login.html#/`;
    let redirectUrl = where;
    if (!where || where === "home") {
        redirectUrl = home;
    } else if (where === "login") {
        redirectUrl = login;
    }
    window.location.href = redirectUrl;
}

export async function businessSetting() {
    const resp = await ajax.get("/xiaoyue-operation/business/getRobotsInfo");
    return {
        businessName: resp.business_name,
        languages: resp.langlist ? resp.langlist.split(",") : [],
        modules: resp.permit_code ? resp.permit_code.split(",") : [],
        robots: (resp.robot_info || []).map(rInfo => ({
            gameId: rInfo.game_id,
            robotName: rInfo.game_name,
            source: rInfo.answer_channel ? JSON.parse(rInfo.answer_channel) : [],
            defaultLang: rInfo.default_lang
        }))
    };
}

// 多tab页只需要一个tab页更新token就行了，其他的更新过后更新一下请求头就行
function addStorageListener() {
    window.addEventListener("storage", e => {
        console.log("storage listener emited");
        if (e.key !== tokenStore.TOKEN_KEY) {
            return;
        }
        if (!e.newValue) {
            jump("login");
        }

        info();
    });
}

addStorageListener();
